module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJ5JREFUOE/dkzEOgiEMhXlx8jCuuuoBHPUIBY7UwAF09gQ66uhhnCh/SCSpERxk+xnp60fz+oAZPBjsN3MDMPNKRJbe+3vLmxjjOqX0stY+a/3Dg7fgAuBIRFcNCSFsReQsInv9wJeJVZhzPjjnbgVS71rg5hY0BMDCGHPSQD1Zd43MvCuNRdxrLrWfOWDmDQAhokcvcHML0j8fa9iDCR+NUREL8gsnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top_icon_arrow_closed.png
// module id = cjH1
// module chunks = 1